import { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_URL } from '../config/api';

const Reset = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const query = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const token = query.get('token') || '';
  const email = query.get('email') || '';

  const [formData, setFormData] = useState({
    tempPassword: '',
    password: '',
    confirmPassword: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showTemp, setShowTemp] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token || !email) {
      toast.error('Invite link is invalid or missing details.');
      return;
    }

    if (!formData.tempPassword || !formData.password || !formData.confirmPassword) {
      toast.error('Please fill all fields.');
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      toast.error('Passwords do not match.');
      return;
    }

    if (!API_URL) {
      toast.error('API URL not configured.');
      return;
    }

    setIsSubmitting(true);
    try {
      const payload = {
        action: 'acceptInviteLeadManager',
        token,
        email,
        tempPassword: formData.tempPassword,
        password: formData.password
      };

      const response = await axios.post(API_URL, payload, {
        headers: { 'Content-Type': 'application/json' }
      });

      const result = response.data || {};
      if (result?.success || result?.message) {
        toast.success(result.message || 'Password updated successfully');
        navigate('/');
      } else {
        toast.error(result?.message || 'Failed to update password');
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Request failed';
      toast.error(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-left-panel">
        <div className="login-left-brand">
          <span className="login-brand-dot"></span>
          <div>
            <img
              src="/assets/img/Website_logo_color logo-black text-1.png"
              alt="Office logo"
              className="login-brand-logo"
            />
          </div>
        </div>
        <div className="login-left-illustration">
          <img
            src="/assets/img/reset.png"
            alt="Invite illustration"
            className="login-left-image"
          />
        </div>
      </div>

      <div className="login-right-panel">
        <div className="login-right-inner">
          <h5 className="login-heading">Set Your Password</h5>
          <form onSubmit={handleSubmit} noValidate>
            <div className="login-field">
              <label htmlFor="tempPassword" className="login-label">Temporary Password</label>
              <div className="login-input-row">
                <input
                  type={showTemp ? 'text' : 'password'}
                  id="tempPassword"
                  name="tempPassword"
                  className="login-input-line"
                  placeholder="Enter temporary password"
                  value={formData.tempPassword}
                  onChange={handleChange}
                />
                <button
                  type="button"
                  className="login-eye"
                  onClick={() => setShowTemp(!showTemp)}
                  aria-label={showTemp ? 'Hide temporary password' : 'Show temporary password'}
                >
                  <i className={showTemp ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
                </button>
              </div>
            </div>

            <div className="login-field">
              <label htmlFor="password" className="login-label">New Password</label>
              <div className="login-input-row">
                <input
                  type={showNew ? 'text' : 'password'}
                  id="password"
                  name="password"
                  className="login-input-line"
                  placeholder="Enter new password"
                  value={formData.password}
                  onChange={handleChange}
                />
                <button
                  type="button"
                  className="login-eye"
                  onClick={() => setShowNew(!showNew)}
                  aria-label={showNew ? 'Hide new password' : 'Show new password'}
                >
                  <i className={showNew ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
                </button>
              </div>
            </div>

            <div className="login-field">
              <label htmlFor="confirmPassword" className="login-label">Confirm Password</label>
              <div className="login-input-row">
                <input
                  type={showConfirm ? 'text' : 'password'}
                  id="confirmPassword"
                  name="confirmPassword"
                  className="login-input-line"
                  placeholder="Confirm password"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                />
                <button
                  type="button"
                  className="login-eye"
                  onClick={() => setShowConfirm(!showConfirm)}
                  aria-label={showConfirm ? 'Hide confirm password' : 'Show confirm password'}
                >
                  <i className={showConfirm ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="login-primary-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Updating...' : 'Update Password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Reset;
